var p = (t, i, r) => new Promise((n, s) => {
  var d = (e) => {
    try {
      o(r.next(e));
    } catch (a) {
      s(a);
    }
  }, g = (e) => {
    try {
      o(r.throw(e));
    } catch (a) {
      s(a);
    }
  }, o = (e) => e.done ? n(e.value) : Promise.resolve(e.value).then(d, g);
  o((r = r.apply(t, i)).next());
});
import { selfAxios as m } from "@oppein/op-utils";
function T(t) {
  return p(this, null, function* () {
    return yield m.post(
      "/designapi/design/orderStorageTime/exportOrderStorageTimeDetail",
      t,
      {
        responseType: "blob"
      }
    );
  });
}
export {
  T as postExportOrderStorageTimeDetail
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/designapi/design/orderStorageTime/exportOrderStorageTimeDetail/post.js
// module id = 1804
// module chunks = 67